export enum SearchOrder {
    ASC = 'ASC',
    DESC = 'DESC'
}
